import { _ep0, _mw0, command } from "../commandBuilder";
import { GetSessionToken$ } from "../schemas/schemas_0";
export class GetSessionTokenCommand extends command(_ep0, _mw0, "GetSessionToken", GetSessionToken$) {
}
